<div class="billing-page">

  <app-billing-header></app-billing-header>

  <!-- Transactions ledger -->
  <div class="api-card">
    <div class="api-card__header">
      <div class="api-card__header-stack">
        <span class="api-card__title">Wallet ledger</span>
        <span class="api-card__desc">Every top-up, grant, adjustment, and refund on your wallet.</span>
      </div>
    </div>

    <div class="txn-filter">
      <!-- Same pill tabs as the Playground endpoint switcher (.tab-pill, _playground.scss). -->
      <div class="txn-filter__pills" role="group" aria-label="Filter by type">
        @for (k of kinds; track k) {
          <button
            type="button"
            class="tab-pill"
            [class.tab-pill--active]="selectedKind === k"
            [attr.aria-pressed]="selectedKind === k"
            (click)="setKind(k)"
          ><span class="tab-pill__path">{{ kindLabels[k] }}</span></button>
        }
      </div>
    </div>

    @if (isLoading && !transactions.length) {
      <div aria-busy="true" aria-label="Loading transactions">
        @for (i of [0, 1, 2, 3, 4]; track i) {
          <div class="skeleton-row">
            <app-skeleton width="120px" height="14px"></app-skeleton>
            <app-skeleton width="80px" height="14px"></app-skeleton>
            <app-skeleton width="320px" height="14px"></app-skeleton>
            <app-skeleton width="70px" height="14px"></app-skeleton>
          </div>
        }
      </div>
    } @else if (transactions.length) {
      <app-txn-table [rows]="transactions"></app-txn-table>
    } @else {
      <p class="billing-card__desc" style="padding: 24px;">No transactions to show.</p>
    }
  </div>

  @if (transactions.length >= limit) {
    <p class="billing-footnote">Showing your latest {{ limit }} entries.</p>
  }

</div>
